import React, { useState } from 'react';
import EditFieldModal from '../Edit Field Modal/EditFieldModal';
import AssignedToModal from './AssignedToModal';
import { FaSearch } from 'react-icons/fa';

export default function OSPManagementDetails() {
  const [managementFields, setManagementFields] = useState({
    addedBy: { label: "Seller Added By", placeholder: "Enter Name", type: "required" },
    addedDate: { label: "Seller Added Date", placeholder: "Enter Date", type: "required" },
    source: { label: "Seller Source", placeholder: "Select Seller Source", type: "required" },
    stage: { label: "Seller Stage", placeholder: "Select Seller Stage", type: "required" },
    lastUpdatedBy: { label: "Seller Last Updated By", placeholder: "Enter Name", type: "required" },
    nextStep: { label: "Next Step", placeholder: "Select Next Step", type: "required" },
    owner: { label: "Seller Owner", placeholder: "Select Owner", type: "required" },
    recommendedFor: { label: "Seller Recommended For", placeholder: "Select Role", type: "required" },
    tags: { label: "Tags", placeholder: "Enter Tags", type: "required" },
    assignedTo: { label: "Assigned To", placeholder: "Select", type: "required", value: "" },
  });

  const [editingFieldKey, setEditKey] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAssignedModalOpen, setAssignedModalOpen] = useState(false);

  const [addFieldModalOpen, setAddFieldModalOpen] = useState(false);
  const [selectedFieldType, setSelectedFieldType] = useState('');
  const [sellerManagementDetailModalOpen, setSellerManagementDetailModalOpen] = useState(false);

  const [newFieldDetails, setNewFieldDetails] = useState({
    label: '',
    type: '',
    placeholder: '',
    options: '',
  });

  const handleEditClick = (key) => {
    if (key === 'assignedTo') {
      setAssignedModalOpen(true);
    } else {
      setEditKey(key);
      setIsModalOpen(true);
    }
  };

  const handleSaveField = (updatedField) => {
    setManagementFields((prev) => ({
      ...prev,
      [editingFieldKey]: updatedField,
    }));
    setIsModalOpen(false);
  };

  const handleAssignedSave = (value) => {
    setManagementFields((prev) => ({
      ...prev,
      assignedTo: {
        ...prev.assignedTo,
        value,
      },
    }));
    setAssignedModalOpen(false);
  };

  const handleAddNewField = () => {
    const key = newFieldDetails.label.replace(/\s+/g, '').toLowerCase();
    if (key) {
      setManagementFields((prev) => ({
        ...prev,
        [key]: {
          label: newFieldDetails.label,
          placeholder: newFieldDetails.placeholder,
          type: newFieldDetails.type,
          options: newFieldDetails.options || undefined,
        },
      }));
    }
    setSellerManagementDetailModalOpen(false);
    setNewFieldDetails({ label: '', type: '', placeholder: '', options: '' });
    setSelectedFieldType('');
  };

  return (
    <div className="p-6 bg-white border-2 border-gray-300 my-5 mx-10 rounded-lg shadow-md w-full">
    <div className="p-6 bg-white border-2 border-gray-300 my-5 mx-10 rounded-lg shadow-md ">
      <h2 className="text-xl font-semibold text-gray-800 underline mb-6">OSP Management Details :</h2>
      <div className="grid grid-cols-2 gap-8">
        {Object.entries(managementFields).map(([key, field]) => (
          key === 'assignedTo' ? (
            <div key={key} className="flex flex-col">
              <div className="flex items-center justify-between">
                <label className="text-md font-semibold text-gray-500">
                  {field.label}
                  {field.type === "required" && <span className="text-red-500">*</span>}
                </label>
                <div className="flex gap-4 text-gray-400 text-lg cursor-pointer">
                  <span onClick={() => handleEditClick(key)}>✎</span>
                  <span>✖</span>
                </div>
              </div>
              <div
                onClick={() => handleEditClick(key)}
                className="mt-1 w-full border border-gray-300 rounded-md px-3 py-2 bg-gray-50 cursor-pointer"
              >
                {field.value || "Click to Assign"}
              </div>
            </div>
          ) : (
            <div key={key} className="flex flex-col">
              <div className="flex items-center justify-between">
                <label className="text-md font-semibold text-gray-500">
                  {field.label}
                  {field.type === "required" && <span className="text-red-500">*</span>}
                </label>
                <div className="flex gap-4 text-gray-400 text-lg cursor-pointer">
                  <span onClick={() => handleEditClick(key)}>✎</span>
                  <span>✖</span>
                </div>
              </div>
              <input
                type="text"
                placeholder={field.placeholder}
                // value={field.value || ""}
                // readOnly
                className="mt-1 w-full border border-gray-300 rounded-md px-3 py-2 outline-none"
              />
            </div>
          )
        ))}
      </div>

      {/* Add Field Modal */}
      {addFieldModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white w-full h-fit max-w-2xl rounded-lg shadow-lg p-6">
            <div className='flex items-center justify-between mb-5'>
              <h1 className="text-xl text-gray-900 font-bold">Add Field</h1>
              <h1 onClick={() => setAddFieldModalOpen(false)} className='text-xl text-gray-900 hover:text-red-600 cursor-pointer font-bold'>X</h1>
            </div>

            <div className="relative">
              <input
                type="text"
                placeholder="Search ..."
                className="w-full border p-2 mb-4 border-gray-300 rounded-md bg-gray-200 text-gray-500 outline-none"
              />
              <FaSearch className="absolute right-3 top-3 text-gray-500" />
            </div>

            <h1 className='text-gray-900 underline text-lg my-5'>Field Types:</h1>

            <div className="grid grid-cols-2 gap-3 px-10 mb-5">
              {["Text fields", "Radio", "Date", "Drop Down", "Slider", "Check Box", "Attachment"].map((fieldType) => (
                <label key={fieldType} className="flex items-center text-lg gap-2">
                  <input
                    type="radio"
                    value={fieldType}
                    onChange={() => setSelectedFieldType(fieldType)}
                    checked={selectedFieldType === fieldType}
                  />
                  {fieldType}
                </label>
              ))}
            </div>

            <div className="flex justify-end gap-2 border-t border-gray-300 pt-5">
              <button onClick={() => setAddFieldModalOpen(false)} className="px-4 py-1 bg-gray-300 rounded">Cancel</button>
              <button
                onClick={() => {
                  if (selectedFieldType) {
                    setAddFieldModalOpen(false);
                    setSellerManagementDetailModalOpen(true);
                  } else {
                    alert("Please select a field type");
                  }
                }}
                className="px-4 py-1 bg-blue-600 text-white rounded"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}

      {/* OSP Management Details Modal */}
      {sellerManagementDetailModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white w-full h-[70vh] max-w-xl rounded-lg shadow-lg p-6 overflow-auto">
            <div className='flex items-center justify-between mb-5'>
              <h1 className="text-xl text-gray-900 font-bold">Security Details</h1>
              <h1 onClick={() => setSellerManagementDetailModalOpen(false)} className='text-xl text-gray-900 hover:text-red-600 cursor-pointer font-bold'>X</h1>
            </div>

            <div className="mb-3 flex items-center justify-between gap-5">
              <div className='flex-1'>
                <label className="block text-gray-600 mb-3">Label<span className="text-red-500">*</span></label>
                <input
                  type="text"
                  placeholder="Enter label name"
                  className="w-full border border-gray-300 p-2 rounded"
                  value={newFieldDetails.label}
                  onChange={(e) => setNewFieldDetails({ ...newFieldDetails, label: e.target.value })}
                />
              </div>
              <div className='flex-2'>
                <label className="block text-gray-600 mb-3">Type<span className="text-red-500">*</span></label>
                <select
                  className="w-full border border-gray-300 p-2 rounded"
                  value={newFieldDetails.type}
                  onChange={(e) => setNewFieldDetails({ ...newFieldDetails, type: e.target.value })}
                >
                  <option>Select</option>
                  <option>required</option>
                  <option>non-required</option>
                </select>
              </div>
            </div>

            <div className="mb-3">
              <label className="block text-gray-600 mb-3">Placeholder<span className="text-red-500">*</span></label>
              <input
                type="text"
                placeholder="Enter placeholder"
                className="w-full border border-gray-300 p-2 rounded"
                value={newFieldDetails.placeholder}
                onChange={(e) => setNewFieldDetails({ ...newFieldDetails, placeholder: e.target.value })}
              />
            </div>

            {(selectedFieldType === "Drop Down" || selectedFieldType === "Radio" || selectedFieldType === "Check Box") && (
              <div className="mb-3">
                <label className="block text-gray-600 mb-3">Options<span className="text-red-500">*</span></label>
                <textarea
                  placeholder="Enter options separated by commas ( , )"
                  className="w-full h-36 border border-gray-300 p-2 rounded"
                  value={newFieldDetails.options}
                  onChange={(e) => setNewFieldDetails({ ...newFieldDetails, options: e.target.value })}
                />
              </div>
            )}
          </div>
        </div>
      )}

      <div className='grid grid-cols-2 items-center px-10 mt-6'>
        <div className='flex items-center justify-end'>
          <button
            onClick={() => setAddFieldModalOpen(true)}
            className="px-3 py-1 bg-gray-200 font-medium text-gray-600 rounded-md"
          >
            Add Field
          </button>
        </div>
        <div className='flex items-center justify-end'>
          <button
            onClick={() => setAddFieldModalOpen(true)}
            className="px-3 py-1 bg-gray-200 font-medium text-gray-600 rounded-md"
          >
            Add Field
          </button>
        </div>
      </div>

      {/* Assigned To Modal */}
      <AssignedToModal
        isOpen={isAssignedModalOpen}
        onClose={() => setAssignedModalOpen(false)}
        onSave={handleAssignedSave}
        selectedValue={managementFields.assignedTo.value || ""}
      />

      {/* Field Edit Modal */}
      <EditFieldModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        fieldData={editingFieldKey ? managementFields[editingFieldKey] : {}}
        onSave={handleSaveField}
        content={"OSP Management Details"}
      />
    </div>
    </div>
  );
}